/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { lazy, Suspense, useEffect } from "react";

/// Components
import Index from "./jsx";
import { connect, useDispatch } from "react-redux";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

// action
import {
  checkAutoLogin,
  getLoginData,
  runLogoutTimer,
  saveTokenInStorage,
} from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
/// Style
import "./vendor/swiper/swiper-bundle.css";
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import "react-datepicker/dist/react-datepicker.css";
import {
  loadingToggleAction,
  loginConfirmedAction,
} from "./store/actions/AuthActions";
import ForgotPassword from "./jsx/pages/ForgotPassword";
import ChangePassword from "./jsx/pages/ChangePassword";
import PremiumUpgradeReminder from "./jsx/components/PremiumUpgradeReminder";

const SignUp = lazy(() => import("./jsx/pages/Registration"));
// const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const user = JSON.parse(sessionStorage.getItem("userDetails"));
  const token = searchParams.get("token");
  useEffect(() => {
    if (token !== null && user?.result?.user?.ispasswordtemporary !== true) {
      getLoginData(token).then((response) => {
        dispatch(loadingToggleAction(true));
        saveTokenInStorage(response.data);
        runLogoutTimer(dispatch, 60 * 60 * 1000, navigate);
        dispatch(loginConfirmedAction(response.data));
        navigate("/business");
      });
    }
  }, [searchParams]);

  useEffect(() => {
    if (user?.result?.user?.ispasswordtemporary !== true) {
      checkAutoLogin(dispatch, navigate);
    }
  }, []);

  let routesBlog = (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<SignUp />} />
      <Route path="/changepassword" element={<ChangePassword />} />
    </Routes>
  );
  if (
    props.isAuthenticated &&
    user?.result?.user?.ispasswordtemporary !== true
  ) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
        </Suspense>
        <PremiumUpgradeReminder />
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routesBlog}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));
